// GroupName: { <key>: <response text from server> }
export enum GroupName {
  "TenantOwner" = "Tenant Owner",
  "TenantAdmin" = "Tenant Admin",
  "TenantUser" = "Tenant User",
}

export type GroupId = number;
export interface Group {
  id: GroupId;
  name: GroupName;
  number?: number;
}

export const GROUP_NAME_TEXT: Record<string, string> = {
  [GroupName.TenantOwner]: "GROUP.TENANT_OWNER",
  [GroupName.TenantAdmin]: "GROUP.TENANT_ADMIN",
  [GroupName.TenantUser]: "GROUP.TENANT_USER",
};
